import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { changePassword, me } from '@/api/auth';
import { useAuthStore } from '@/store/authStore';
import styles from './LoginPage.module.css';

export function ChangePasswordPage() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const setUser = useAuthStore((s) => s.setUser);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (next !== confirm) {
      setError('La nueva contraseña y la confirmación no coinciden.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await changePassword(current, next);
      const user = await me();
      setUser(user);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || 'No se pudo cambiar la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.shell}>
      <form className={styles.card} onSubmit={submit}>
        <div className={styles.brand}>
          <div className={styles.logo}>🔒</div>
          <div className={styles.brandText}>
            <div className={styles.brandTitle}>Cambiar contraseña</div>
            <div className={styles.brandSub}>Tu primer acceso</div>
          </div>
        </div>

        <label className={styles.label}>
          <span>Contraseña actual</span>
          <input
            type="password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
            autoFocus
            className={styles.input}
          />
        </label>

        <label className={styles.label}>
          <span>Nueva contraseña (mín 8 caracteres)</span>
          <input
            type="password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            minLength={8}
            required
            className={styles.input}
          />
        </label>

        <label className={styles.label}>
          <span>Confirmar nueva contraseña</span>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            minLength={8}
            required
            className={styles.input}
          />
        </label>

        {error && <div className={styles.error}>{error}</div>}

        <button className={styles.submitBtn} type="submit" disabled={loading}>
          {loading ? 'Guardando…' : 'Cambiar contraseña'}
        </button>
      </form>
    </div>
  );
}
